import { useEffect } from "react";
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody } from "@chakra-ui/modal";
import { Button } from "@chakra-ui/react";
import { HStack } from "@chakra-ui/layout";
import { useDisclosure } from "@chakra-ui/hooks";
import { useSelector } from "react-redux";
import { userStateSelector } from "store/userSlice";

const WrongChainError = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { chainType, account } = useSelector(userStateSelector);

  const switchToTestnet = async () => {
    const ethereum = window.provider;
    try {
      await ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x61" }],
      });
      onClose();
    } catch (switchError) {
      // This error code indicates that the chain has not been added to MetaMask.
      if (switchError.code === 4902) {
        try {
          await ethereum.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: "0x61",
                chainName: "BscTestnet",
                rpcUrls: ["https://data-seed-prebsc-1-s1.binance.org:8545/"],
              },
            ],
          });
          onClose();
        } catch (addError) {
          // handle "add" error
        }
      }
      // handle other "switch" errors
    }
  };

  const switchToMainnet = async () => {
    const ethereum = window.provider;
    try {
      await ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x38" }],
      });
      onClose();
    } catch (switchError) {
      // This error code indicates that the chain has not been added to MetaMask.
      if (switchError.code === 4902) {
        try {
          await ethereum.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: "0x38",
                chainName: "BSC Mainnet",
                rpcUrls: ["https://bsc-dataseed.binance.org/"],
              },
            ],
          });
          onClose();
        } catch (addError) {
          // handle "add" error
        }
      }
      // handle other "switch" errors
    }
  };

  useEffect(() => {
    if (account !== "" && !chainType) {
      onOpen();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chainType, account]);

  return (
    <>
      <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign={"center"} color={"red.400"}>
            Wrong chain selected!
          </ModalHeader>
          <ModalBody pb={6}>
            <HStack spacing={8}>
              <Button
                w={"100%"}
                variant={"outline"}
                borderColor={"brand.700"}
                fontSize={"sm"}
                color={"gray.700"}
                _hover={{ bg: "brand.700", color: "white", cursor: "pointer" }}
                onClick={switchToMainnet}
              >
                Switch to BSC mainnet
              </Button>
              <Button
                w={"100%"}
                variant={"outline"}
                borderColor={"brand.700"}
                fontSize={"sm"}
                color={"gray.700"}
                _hover={{ bg: "brand.700", color: "white", cursor: "pointer" }}
                onClick={switchToTestnet}
              >
                Switch to BSC testnet
              </Button>
            </HStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default WrongChainError;
